<script setup lang='ts'>
import { ref, computed } from 'vue';
import type { InputHTMLAttributes, PropType } from 'vue';
import { Eye, EyeOff } from 'lucide-vue-next';

const emit = defineEmits(['update:modelValue']);

const updateValue = (event: Event) => {
  emit('update:modelValue', (event.target as HTMLInputElement)?.value || '');
};

const props = defineProps({
  placeholder: String,
  modelValue: String,
  type: {
    type: String as PropType<InputHTMLAttributes['type']>,
    default: 'text'
  },
  valid: {
    type: Boolean,
    default: true
  }
});

const isPassword = props.type == 'password';
const showPassword = ref<boolean>(!isPassword);

const inputType = computed(() => isPassword
  ? showPassword.value
    ? 'text'
    : 'password'
  : props.type);

const toggle = () => showPassword.value = !showPassword.value;
</script>

<template>
  <div class="relative">
    <input
      :type="inputType"
      class="w-full border-1 focus:border-2 h-12 rounded-xl border-onboard-shade1 focus:border-onboard-shade2 bg-onboard-background text-center outline-none"
      :class="{ 'border-red-500': !valid, 'px-10': isPassword }"
      :placeholder="props.placeholder"
      :value="modelValue"
      @input="updateValue"
      autocomplete="new-password"
    />
    <div
      v-if="isPassword"
      class="absolute top-3 right-3"
    >
      <EyeOff
        v-if="showPassword"
        class="transition-opacity duration-300"
        :class="{ 'opacity-50': !props.modelValue, 'opacity-90 cursor-pointer': props.modelValue }"
        @click="toggle"
      />
      <Eye
        v-else
        class="transition-opacity duration-300"
        :class="{ 'opacity-50': !props.modelValue, 'opacity-90 cursor-pointer': props.modelValue }"
        @click="toggle"
      />
    </div>
  </div>
</template>
